import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";
export var HowDoesSignupWorkIA = function HowDoesSignupWorkIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return HOW_DOES_SIGNUP_OFFER_WORK_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [HOW_DOES_SIGNUP_OFFER_WORK_DESCRIPTION(strictLocalize)];
    }
  };
};
var HOW_DOES_SIGNUP_OFFER_WORK_TITLE = function HOW_DOES_SIGNUP_OFFER_WORK_TITLE(strictLocalize) {
  if (getSettingRetailerExclusivityAgreements()) {
    return strictLocalize({
      id: "JvfdpN",
      defaultMessage: [{
        "type": 0,
        "value": "Zo claim je een aanbieding"
      }]
    });
  } else {
    return strictLocalize({
      id: "w7CyhN",
      defaultMessage: [{
        "type": 0,
        "value": "Zo werkt de registratie-aanbieding"
      }]
    });
  }
};
var HOW_DOES_SIGNUP_OFFER_WORK_DESCRIPTION = function HOW_DOES_SIGNUP_OFFER_WORK_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "x52u0e",
    defaultMessage: [{
      "type": 0,
      "value": "Wanneer je je registreert op Faire via de link van een merk, ontvang je een registratie-aanbieding, inclusief een promotie en een jaar gratis verzending bij dat merk. De aanbieding wordt automatisch toegepast bij het afrekenen en verloopt 7 dagen nadat je je registreert."
    }]
  });
};